import { buildClarityWorkspaceUrl } from './build-clarity-workspace-url.util';
import {
	readClarityWorkspaceRoute,
	toClaritySectionUrl,
	toNavigationUnlessCurrent,
} from './clarity-workspace-route.util';
import type { ClarityDashboardTab } from './constants/clarity-dashboard-tabs.constant';
import type { ClarityWorkspaceNavigation } from './models/clarity-workspace-navigation.model';
import { parseClarityWorkspaceLocation } from './parse-clarity-workspace-location.util';

/** Ported from Clarity `apps/web/src/shared/hooks/useWorkspaceRoute.ts` (commit `f9217bb5a`). */
/**
 * Switching the workspace tab — brain's `goToTab(tab)`: a **replace** (their K12) to the current domain's
 * `tab` that drops `doc`, `file`, `page`, `oi` and `action`, carries every other query key verbatim, and
 * is `null` — no navigation — when that URL is `currentUrl` (their TR-014).
 *
 * Only the integration is adapted: the current URL is an argument read at call time, the answer sits
 * under `sectionPath`, and the navigation is handed back rather than performed.
 */
export function toClarityTabNavigation(
	currentUrl: string,
	sectionPath: string,
	tab: ClarityDashboardTab,
): ClarityWorkspaceNavigation | null {
	const current = readClarityWorkspaceRoute(currentUrl, sectionPath);
	const { domainId } = parseClarityWorkspaceLocation(current.params, current.search);
	const url = buildClarityWorkspaceUrl(
		{ domainId, tab, doc: null, page: null, file: null, oi: null, action: null },
		current.search,
	);

	return toNavigationUnlessCurrent(current, toClaritySectionUrl(sectionPath, url), true);
}
